export { SORT_TYPES } from './sortTypes';

export const REFUNDS_COLUMNS = [
  { id: 'customer_name', label: 'Customer', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'customer_email', label: 'Email', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'event_name', label: 'Event', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'reason', label: 'Reason', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'amount', label: 'Amount', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'state', label: 'Status', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'refund_type', label: 'Type', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'created_at', label: 'Created', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'confirmed_at', label: 'Confirmed', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'date' },
];

export const getDefaultVisibleColumns = () =>
  REFUNDS_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  REFUNDS_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
